import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../../i18n';

export default function LegalLanguageMenu({ className = '' }) {
  const { language, languages, setLanguage } = useI18n();
  const currentLanguage = languages.find((item) => item.code === language) || languages[0];
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handlePointerDown(event) {
      if (!ref.current?.contains(event.target)) setOpen(false);
    }
    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, []);

  return (
    <div className={`ct-language-menu ${className}`.trim()} ref={ref}>
      <button
        type="button"
        className="ct-language-trigger"
        onClick={() => setOpen((value) => !value)}
        aria-label={currentLanguage.label}
        aria-expanded={open}
      >
        <span aria-hidden="true">{currentLanguage.flag}</span>
        <i className="ph ph-caret-down"></i>
      </button>
      {open ? (
        <div className="ct-language-options" role="menu">
          {languages.map((item) => (
            <button
              key={item.code}
              type="button"
              role="menuitem"
              className={item.code === language ? 'active' : ''}
              onClick={() => {
                setLanguage(item.code);
                setOpen(false);
              }}
            >
              <span aria-hidden="true">{item.flag}</span>
              <strong>{item.label}</strong>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
